import {createReducer} from "@reduxjs/toolkit";
import type { AppContext } from "../entity/appContext.ts";
import { setCurrentTenantAction } from "../action/setCurrentTenantAction.ts";
import { isAddApplicationDialogOpenAction } from "../action/isAddApplicationDialogOpenAction.ts";
import { isAddUserDialogOpenAction } from "../action/IsAddUserDialogOpenAction.ts";
import { showBackButtonAction } from "../action/showBackButtonAction.ts";

export const appContextReducer = createReducer({} as AppContext, (builder) => {
    builder.addCase(setCurrentTenantAction, (state, action) => ({
        ...state,
        currentTenant: action.payload.tenant
    }));
    builder.addCase(isAddApplicationDialogOpenAction, (state, action) => ({
        ...state,
        isAddApplicationDialogOpen: action.payload.isOpen
    }));
    builder.addCase(isAddUserDialogOpenAction, (state, action) => ({
        ...state,
        isAddUserDialogOpen: action.payload.isOpen
    }));
    builder.addCase(showBackButtonAction, (state, action) => ({
        ...state,
        showBackButton: action.payload.show
    }));
});
